import { Injectable, Inject, forwardRef } from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { getManager } from 'typeorm';
import { ReceiptsDTO } from './dto/receipts.dto';
import { networkInterfaces } from 'os';
import { count } from 'console';
@Injectable()
export class ReceiptsService {

  constructor(   
  ) {}
  async saveReceipt(receipt:ReceiptsDTO):Promise<any> {
    const manager = getManager();
    let collection_status=1;
    var cheque_status=0;
    var today = new Date(receipt.payment_date);
    var year = today.getFullYear();
    var mes = today.getMonth()+1;
    var dia = today.getDate();
    var paymentDate =year+"-"+mes+"-"+dia;  

	if(receipt.payment_mode=='Cheque'){
		cheque_status=1;
	}
    let loanQuery='select loandetails.Loan_Account_Number as Loan_Account_Number,customers.customer_name as customer_name,emi,loandetails.branch_name as branch_name,loandetails.Executive_Name as executive_name from loandetails left join customers on customers.id=loandetails.customer_name where loandetails.id='+receipt.loanId;
    let loanData=await manager.query(loanQuery);
    if(Object.values(loanData).length>0){
      for (const loan of loanData) {
        console.log(loan.Loan_Account_Number);
        var receiptQuery='INSERT INTO receipts (date_time,Loan_Account_Number,amount_paid,customer_name,emi,emi_amount_paid,schedule_emi,emi_due_date,emi_paid_date,collection_status,Branch,Executive_Name,payment_type,payment_mode,receipt_number,phone,Cheque_Date,Cheque_No,Bank_Name,Bank_Branch,Remarks,cheque_status,service_chrg_percent,service_chrg_amount,collection_executive_name,cheque_amount,bank_det,req_type) VALUES (now(,"'+loan.Loan_Account_Number+'", '+receipt.amount_paid+',"'+loan.customer_name+'",'+loan.emi+',0,0,"'+paymentDate
        +'","'+paymentDate+'",1,'+loan.branch_name+','+loan.executive_name+',"'+receipt.payment_type+'","'+receipt.payment_mode+'","'+receipt.receipt_number+'","'+receipt.phone+'","'+receipt.cheque_date+'","'+receipt.cheque_number+'","'+receipt.bank_name+'","'+receipt.bank_branch+'","'+receipt.remarks+'","'+cheque_status+'",'+receipt.service_charge_percentage+','+receipt.service_charge_amount+','+receipt.employeeId+','+receipt.cheque_amount+',0,0'+')';
      }     
      // console.log(query);l
      const receiptResult = await manager.query(receiptQuery);
      console.log('receiptResult');
      console.log(receiptResult.code);
      console.log(Object.values(receiptResult).length);
      return true; 
    }else{
      return false;
    }
    
  }
}